import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date) {
  return format(new Date(date), 'yyyy-MM-dd');
}

export function fDateTime(date) {
  return format(new Date(date), 'dd MMM yyyy HH:mm');
}

export function fTime(date) {
  return format(new Date(date), 'HH:mm:ss');
}

export function fTimestamp(date) {
  return getTime(new Date(date));
}

export function fDateTimeSuffix(date) {
  return format(new Date(date), 'dd/MM/yyyy hh:mm p');
}

export function fToNow(date) {
  return formatDistanceToNow(new Date(date), {
    addSuffix: true
  });
}

/**
 * Formate une date pour l'envoyer à l'API sans conversion timezone
 * Utilise les méthodes locales (getFullYear, getMonth, getDate) 
 * pour éviter les décalages d'un jour
 * 
 * @param {Date|string} date - Date à formater
 * @returns {string|null} Date au format 'yyyy-MM-dd' ou null
 */
export function fDateForAPI(date) {
  if (!date) return null;
  
  // Si c'est déjà un string au format yyyy-MM-dd, le retourner tel quel
  if (typeof date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(date)) {
    return date;
  }
  
  // Extraire année/mois/jour directement de l'objet Date (timezone local)
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  
  return `${year}-${month}-${day}`;
}